import React from 'react';

import { buildContext } from '@tectonics/utils/context';

const submittingContext = buildContext<boolean>('SubmittingContext');

interface SubmittingProviderProps {
  readonly submitting: boolean;
  readonly children: React.ReactNode;
}

export function SubmittingProvider({
  submitting,
  children,
}: SubmittingProviderProps): React.ReactNode {
  return (
    <submittingContext.Context.Provider value={submitting}>
      {children}
    </submittingContext.Context.Provider>
  );
}

export function useSubmitting(): boolean {
  return submittingContext.useContext();
}
